module.exports = __webpack_public_path__ + "static/media/invite-members-corporate.945017d7.png";